import axios from 'axios';

import merge from 'lodash/merge';

import { reissueAzureB2CTokens } from '@/api/azureB2C';
import { reissueAzureB2CRefreshToken } from '@/api/requestInterceptor';

import { getAuthTokens, putAuthTokens } from '@/utils/localStorage/authentication';

import { store } from '@/store/store';

import logger from '@/utils/logger';

export const API_URL = process.env.API_URL || '';

// FIXME: Use one single httpClient
class HttpClient {
  constructor() {
    this.setupHeaders();
  }

  setupHeaders() {
    const defaultHeaders = {
      Accept: 'application/json',
    };

    const tokens = getAuthTokens();
    if (tokens) {
      defaultHeaders.Authorization = `Bearer ${tokens.access_token}`;
    }

    const state = (store && typeof store.getState === 'function' && store.getState()) || {};
    const language = state.language || { selectedLanguage: 'en' };
    const shop = state.shop || {};

    if (shop.shopId) {
      defaultHeaders['shopId'] = shop.shopId;
    }

    const langId = language.selectedLanguage || 'en';
    defaultHeaders['Accept-Language'] = langId;

    const httpClient = axios.create({
      timeout: 30000,
      headers: defaultHeaders,
    });

    this.axios = httpClient;
    this.registerAuthHeaderInterceptor(store);
  }

  get(path, body, config) {
    return this.makeRequest('get', path, body, config);
  }

  put(path, body, config) {
    return this.makeRequest('put', path, body, config);
  }

  post(path, body, config) {
    return this.makeRequest('post', path, body, config);
  }

  patch(path, body, config) {
    return this.makeRequest('patch', path, body, config);
  }

  delete(path, body, config) {
    return this.makeRequest('delete', path, body, config);
  }

  // FIXME: Refactor and reuse requestInterceptorHandler from @/api/requestInterceptor
  registerAuthHeaderInterceptor = store => {
    this.axios.interceptors.request.use(config => {
      const tokens = getAuthTokens();
      if (tokens) {
        config.headers.Authorization = `Bearer ${tokens.access_token}`;
      }
      return config;
    });

    this.axios.interceptors.response.use(null, async error => {
      if (error.response.status === 401) {
        const tokens = getAuthTokens();

        try {
          const { data } = await reissueAzureB2CTokens(tokens.refresh_token);
          putAuthTokens(data);
        } catch (e) {
          const { selectedLanguage } = store.getState().language;
          reissueAzureB2CRefreshToken(selectedLanguage);
          return Promise.reject(error);
        }

        return axios(error.config);
      }

      logger.toAppInsights(error.response);

      return Promise.reject(error);
    });
  };

  makeRequest(type, path, body, config = {}) {
    return this.axios[type](API_URL + path, body, merge(this.defaultConfig, config));
  }
}

export default HttpClient;
